import * as types from '../ActionTypes/ExercisesActionTypes';

export class ExercisesActionCreators {
    // All exercises
    static getAllExercisesRequest = filter => ({
        type: types.GET_ALL_EXERCISES_REQUEST,
        meta: { filter },
    });

    static getAllExercisesSuccess = (response, offsetId) => ({
        type: types.GET_ALL_EXERCISES_SUCCESS,
        payload: { response, offsetId },
    });

    static getAllExercisesFailed = payload => ({
        type: types.GET_ALL_EXERCISES_FAILED,
        payload,
    });

    // more exercises
    static getMoreExercisesRequest = (filter, offsetId) => ({
        type: types.GET_MORE_EXERCISES_REQUEST,
        meta: { filter, offsetId },
    });

    static getMoreExercisesSuccess = (response, offsetId) => ({
        type: types.GET_MORE_EXERCISES_SUCCESS,
        payload: { response, offsetId },
    });

    static noMoreExercises = () => ({
        type: types.NO_MORE_EXERCISES,
    });

    static getMoreExercisesFailed = payload => ({
        type: types.GET_MORE_EXERCISES_FAILED,
        payload,
    });

    // Recent exercises
    static getRecentExercisesRequest = () => ({
        type: types.GET_RECENT_EXERCISES_REQUEST,
    });

    static getRecentExercisesSuccess = payload => ({
        type: types.GET_RECENT_EXERCISES_SUCCESS,
        payload,
    });

    static getRecentExercisesFailed = payload => ({
        type: types.GET_RECENT_EXERCISES_FAILED,
        payload,
    });

    // Exercises by type
    static getExercisesByTypeRequest = (key, filter) => ({
        type: types.GET_EXERCISES_BY_TYPE_REQUEST,
        meta: { key, filter },
    });

    static getExercisesByTypeSuccess = (response, offsetId) => ({
        type: types.GET_EXERCISES_BY_TYPE_SUCCESS,
        payload: { response, offsetId },
    });

    static getExercisesByTypeFailed = payload => ({
        type: types.GET_EXERCISES_BY_TYPE_FAILED,
        payload,
    });

    // more exercises by type
    static getMoreExercisesByTypeRequest = (key, filter, offsetId) => ({
        type: types.GET_MORE_EXERCISES_BY_TYPE_REQUEST,
        meta: { key, filter, offsetId },
    });

    static getMoreExercisesByTypeSuccess = (response, offsetId) => ({
        type: types.GET_MORE_EXERCISES_BY_TYPE_SUCCESS,
        payload: { response, offsetId },
    });

    static getMoreExercisesByTypeFailed = payload => ({
        type: types.GET_MORE_EXERCISES_BY_TYPE_FAILED,
        payload,
    });

    static noMoreExercisesByType = () => ({
        type: types.NO_MORE_EXERCISES_BY_TYPE,
    });
}



// WEBPACK FOOTER //
// ./src/Store/ActionCreators/ExercisesActionCreators.js